import { OfferBase } from './bases/offer-base';
import { Segment } from './segment';
import { map } from 'lodash';

export class OfferMixed extends OfferBase {
  cashback_rate = 25;
  commission_rate = 25;
  total_amount = 0;
  min_amount = null;
  max_amount = null;
  cashback_budget = null;
  completion: any = null;
  animation_delay_days = 0;
  coupon_generic_code = '';
  coupon_total_number = 0;
  total_consumers = 0;
  is_activated: true;
  legal_terms: string;
  reference: string;
  strategy_id: string;
  segments: Segment[] = [];
  audience: { actual: number; computed_at: string; download_url: string } = null;
  isCoupon = false;

  constructor(payload: Object = {}) {
    super();

    Object.assign(this, payload);

    if (this.type === 'CASHBACK' && this.cashback_budget) {
      this.completion = (this.total_amount / this.cashback_budget) * 100;
    }

    if (this.type === 'GENERIC_COUPON' && this.coupon_total_number) {
      this.completion = (this.total_consumers / this.coupon_total_number) * 100;
    }

    if (this.type === 'UNIQUE_COUPON' && this.coupon_total_number) {
      this.completion = (this.total_consumers / this.coupon_total_number) * 100;
    }

    this.isCoupon = this.type === 'GENERIC_COUPON' || this.type === 'UNIQUE_COUPON'

    this.trimTimezoneFromDates();
  }

  getSegmentList(separator = ', ') {
    return map(this.segments, 'name').join(separator);
  }
}
